import { useNavigate } from "react-router-dom";
import { ArrowUpRight, ArrowLeft } from "lucide-react";

// Google Play Billing compliance screen — shown in place of any web checkout/pricing
// when the app runs inside the Android app. Sends the user to their phone browser to
// complete the purchase legally outside the app.
export const AppBillingNotice = ({ onBack }) => {
  const nav = useNavigate();
  const url = `${window.location.origin}/upgrade?src=app`;
  const back = onBack || (() => nav(-1));

  return (
    <div
      data-testid="app-billing-notice"
      className="mx-auto flex max-w-sm flex-col items-center px-6 py-10 text-center"
    >
      <img
        src="/airwave-icon.png"
        alt="Air Wave"
        className="h-16 w-16 rounded-2xl object-contain ring-1 ring-white/10"
      />
      <h2 className="mt-6 font-display text-2xl font-black tracking-tight">
        Upgrades happen on the web
      </h2>
      <p className="mt-2 text-sm text-white/65">
        To subscribe, go Premium or add coins, open the upgrade page in your browser — it only takes a second.
      </p>

      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="open-upgrade-page-btn"
        className="mt-7 inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#FF0055] px-6 py-3 font-bold text-white transition-transform hover:-translate-y-0.5"
      >
        Open upgrade page <ArrowUpRight size={17} />
      </a>

      <button
        onClick={back}
        data-testid="billing-notice-back"
        className="mt-3 inline-flex items-center justify-center gap-1.5 rounded-full px-6 py-2.5 text-sm font-semibold text-white/70 transition-colors hover:text-white"
      >
        <ArrowLeft size={15} /> Go back
      </button>
    </div>
  );
};
